"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkVariantNames = exports.defaultControlVariantId = exports.integrationGoalMetricCacheKeyPrefix = exports.stopTrackingLinkDefaultText = exports.nativeFormTrackingConsentShownField = exports.nativeFormTrackingConsentField = exports.nativeFormMarketingConsentField = exports.maxExportPeopleChunkSize = exports.maxPersonFieldLength = exports.ourEnchargeAccountId = exports.requireMailingAddressInEmailsFromAccountId = exports.enchargeSiteTrackingSlug = exports.replyDomain = exports.maxTestEmails = exports.maxEmailSpamBlockRetries = exports.defaultUnsubscribeSuccessURL = exports.apiURL = exports.appURL = exports.emailValidationAPIKey = exports.emailValidationAPIURL = exports.screenshotsURL = exports.peoplePageSize = exports.transactionalAdHocEmailID = exports.testEmailID = exports.masterAccountID = exports.invalidServiceCredentials = exports.emptyServiceCredentials = exports.authReasonWrongCredentials = exports.authReasonExpired = exports.authReasonNoCredentials = exports.integrationStateDeactivatedExpiredAuth = exports.integrationStateDeactivatedGeneric = exports.integrationStateDeactivatedByUser = exports.integrationStateActive = void 0;
exports.integrationStateActive = "on";
exports.integrationStateDeactivatedByUser = "deactivated-user";
exports.integrationStateDeactivatedGeneric = "deactivated";
exports.integrationStateDeactivatedExpiredAuth = "deactivated-expired-auth";
exports.authReasonNoCredentials = "no_credentials";
exports.authReasonExpired = "expired";
exports.authReasonWrongCredentials = "wrong_credentials";
exports.emptyServiceCredentials = "empty_credentials";
exports.invalidServiceCredentials = "invalid_credentials";
exports.masterAccountID = 1;
exports.testEmailID = -1;
exports.transactionalAdHocEmailID = -12345;
exports.peoplePageSize = 100;
exports.screenshotsURL = "https://screenshots.encharge.io";
exports.emailValidationAPIURL = process.env.EMAIL_VALIDATION_API_URL ||
    "https://email-validation.encharge.io";
exports.emailValidationAPIKey = process.env.EMAIL_VALIDATION_API_KEY;
exports.appURL = process.env.APP_URL ||
    // This needs to be in brackets or it will default to staging-app for some reason
    // eslint-disable-next-line no-nested-ternary
    (process.env.NODE_ENV === "staging"
        ? "https://staging-app.encharge.io"
        : process.env.NODE_ENV === "development"
            ? "https://development-app.encharge.io"
            : "https://app.encharge.io");
exports.apiURL = process.env.URL_BASE || "https://api.encharge.io";
exports.defaultUnsubscribeSuccessURL = `${exports.appURL}/unsubscribed.html`;
exports.maxEmailSpamBlockRetries = 2;
exports.maxTestEmails = 5;
exports.replyDomain = "reply.encharge-mail.com";
exports.enchargeSiteTrackingSlug = "encharge-js";
exports.requireMailingAddressInEmailsFromAccountId = 11043;
exports.ourEnchargeAccountId = process.env.NODE_ENV === "production" ? 88 : 2;
exports.maxPersonFieldLength = 5000;
// How many people can we export at once?
exports.maxExportPeopleChunkSize = 50000;
exports.nativeFormMarketingConsentField = "nativeFormMarketingConsent";
// Name of the tracking consent checkbox in a native form submission.
exports.nativeFormTrackingConsentField = "nativeFormTrackingConsent";
// Hidden input rendered next to the tracking consent checkbox (value "1").
// Its presence proves the submitter was shown the checkbox, so an unticked
// box can mean "denied". Without it (an old embed, or plain HTML exported
// before the checkbox was added) the submission leaves trackingConsent alone.
exports.nativeFormTrackingConsentShownField = "nativeFormTrackingConsentShown";
// The words of {{person.stopTrackingLink}} in an email, and of the button on
// the page it opens. An account can replace them (its customised preferences
// page texts use this sentence as the key).
exports.stopTrackingLinkDefaultText = "Refuse email tracking";
exports.integrationGoalMetricCacheKeyPrefix = `integrationGoalMetric`;
exports.defaultControlVariantId = "00000000-0000-0000-0000-000000000000";
/**
 * The dark-theme colour variants the app ships.
 *
 * Canonical: the frontend's theme manager and the API's appearance endpoint
 * both read this, so adding a variant cannot leave the server silently
 * dropping it - which would apply locally and never follow the user to
 * another machine, with no error anywhere.
 *
 * Two copies cannot import it and are checked by a test instead: the palettes
 * in _dark.scss (CSS) and the pre-paint map in public/index.html (inline
 * script that must run before any bundle loads).
 */
// Deliberately plain: every other value in this file is JS-compatible, and the
// frontend loads it without TypeScript processing - `as const` here broke the
// build. The matching union type lives in the frontend's theme.ts and is held
// in step by variants.consistency.spec.ts.
exports.darkVariantNames = [
    "charcoal",
    "midnight",
    "carbon",
    "espresso",
    "forest",
];
//# sourceMappingURL=constants.js.map